import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const userService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.user.base, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
    login: async (data) => {
        try {
            const res = await axiosService.post(endPoints.user.login, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.user.base}${id}`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    updateById: async (id, data) => {
        try {
            const res = await axiosService.patch(`${endPoints.user.base}${id}/`, data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return res;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

export {
    userService,
}
